export const MESSAGE_RETRY_ERROR_CODES: ReadonlySet<number> = new Set([504]);
